import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Navbar from "../home/components/Navbar";
import Footer from "../home/components/Footer";
import QuoteModal from "../home/components/QuoteModal";
import ServiceHero from "./components/ServiceHero";
import HowItWorks from "./components/HowItWorks";
import PricingSection from "./components/PricingSection";
import ServiceFAQ from "./components/ServiceFAQ";
import NotFound from "../NotFound";
import { servicePages } from "../../mocks/servicePages";

export default function ServicePage() {
  const { slug } = useParams<{ slug: string }>();
  const [modalOpen, setModalOpen] = useState(false);

  const service = servicePages.find((s) => s.slug === slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!service) return <NotFound />;

  return (
    <main className="font-sans bg-white">
      <Navbar onBookNow={() => setModalOpen(true)} />
      <ServiceHero service={service} onBookNow={() => setModalOpen(true)} />
      <HowItWorks steps={service.steps} />
      <PricingSection
        accepts={service.accepts}
        service={service}
        onBookNow={() => setModalOpen(true)}
      />
      <ServiceFAQ faqs={service.faqs} onBookNow={() => setModalOpen(true)} />
      <Footer />
      <QuoteModal isOpen={modalOpen} onClose={() => setModalOpen(false)} />

      <div className="fixed bottom-6 right-6 z-40 md:hidden">
        <button
          onClick={() => setModalOpen(true)}
          className="bg-cl-dark text-white font-bold px-6 py-3.5 rounded-full cursor-pointer whitespace-nowrap flex items-center gap-2 cartoon-btn"
        >
          <i className="ri-price-tag-3-line"></i>
          Book Now
        </button>
      </div>
    </main>
  );
}